import * as hbApp from '@app/hb-app'
import { bindFunctions } from '@app/utils/class'
import { getItem, setItem, StorageKey } from '@app/utils/localStorage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import * as React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import './ReleaseNotesButton.scss'
import { ReleaseNotesScope, ReleaseNotesViewer } from './ReleaseNotesViewer'

interface IReleaseNotesButtonProps {
  className?: string
  style?: React.CSSProperties
}

interface IReleaseNotesButtonState {
  isNew: boolean
  show: boolean
}

export class ReleaseNotesButton extends React.PureComponent<
  IReleaseNotesButtonProps,
  IReleaseNotesButtonState
> {
  constructor(props: IReleaseNotesButtonProps) {
    super(props)
    this.state = {
      isNew: false,
      show: false,
    }
    bindFunctions(this)
  }

  public componentDidMount() {
    return getItem<string>(StorageKey.LastReleaseNotesVersion).then(
      (lastVersion) => {
        if (!lastVersion || lastVersion !== hbApp.version) {
          this.setState({ isNew: true })
        }
      },
    )
  }

  public render() {
    const iconClasses = classNames('release-notes-button', {
      unseen: this.state.isNew,
    })

    return (
      <span>
        <a
          className={this.props.className}
          id='whats-new-button'
          onClick={this._showModal}
          style={this.props.style}
          title={`What's new`}
        >
          <FontAwesomeIcon
            className={iconClasses}
            icon={['fal', 'gift']}
            fixedWidth
            size='lg'
          />
          <Modal isOpen={this.state.show} size='lg' toggle={this._hideModal}>
            <ModalHeader toggle={this._hideModal}>What&apos;s New?</ModalHeader>
            <ModalBody>
              <div className='release-notes-container'>
                <ReleaseNotesViewer
                  parcelId={hbApp.parcelProjectId}
                  scope={ReleaseNotesScope.Major}
                  version={hbApp.version}
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color='secondary' outline onClick={this._hideModal}>
                <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Close
              </Button>
            </ModalFooter>
          </Modal>
        </a>
      </span>
    )
  }

  private _hideModal() {
    this.setState({ show: false })
  }

  private _showModal() {
    this.setState({ show: true, isNew: false })
    setItem(StorageKey.LastReleaseNotesVersion, hbApp.version)
  }
}
